/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Createaccount1Inputs */

const en_createaccount1 = /** @type {(inputs: Createaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Account`)
};

const de_createaccount1 = /** @type {(inputs: Createaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto erstellen`)
};

/**
* | output |
* | --- |
* | "Create Account" |
*
* @param {Createaccount1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const createaccount1 = /** @type {((inputs?: Createaccount1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Createaccount1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_createaccount1(inputs)
	return de_createaccount1(inputs)
});
export { createaccount1 as "createAccount" }